module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app-bar', {
    staticClass: "kobe-app-bar",
    attrs: {
      "app": "",
      "clipped-left": _vm.$vuetify.breakpoint.xsOnly,
      "dense": _vm.$vuetify.breakpoint.xsOnly,
      "color": "primary",
      "elevate-on-scroll": ""
    }
  }, [(_vm.$vuetify.breakpoint.xsOnly) ? _c('v-app-bar-nav-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('openDrawer')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.xsOnly) ? _c('v-toolbar-title', {
    class: {
      'pl-0': _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('div', {
    staticClass: "toolbar-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Logo"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.xsOnly) ? _c('v-spacer') : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.routerName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showActivePlatform) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [(_vm.showActivePlatform.icon) ? _c('v-icon', {
          staticClass: "pt-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(_vm.showActivePlatform.icon))]) : _vm._e(), _vm._v(" "), (_vm.showActivePlatform.imgIcon) ? _c('img', {
          attrs: {
            "src": _vm.showActivePlatform.imgIcon,
            "width": "20px"
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.showActivePlatform.handle) + " "), _c('v-icon', [_vm._v("mdi-chevron-down")])], 1)]
      }
    }], null, false, 2653615959)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.userPlatforms), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePlatform(obj)
        }
      }
    }, [_c('v-list-item-title', [(obj.icon) ? _c('v-icon', [_vm._v(_vm._s(obj.icon))]) : _vm._e(), _vm._v(" "), (obj.imgIcon) ? _c('img', {
      attrs: {
        "src": obj.imgIcon,
        "width": "20px"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(obj.handle) + "\n          ")], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 370,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "icon": "",
            "size": "40"
          }
        }, on), [_c('img', {
          attrs: {
            "src": _vm.activeUser.avatar
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.profileMenu),
      callback: function($$v) {
        _vm.profileMenu = $$v
      },
      expression: "profileMenu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-item', [_c('v-list-item-avatar', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "size": "75"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.activeUser.avatar,
      "alt": "User Profile Image"
    },
    on: {
      "click": _vm.changeProfilePicture
    }
  })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.activeUser.displayName))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.activeUser.role)), _c('br'), _vm._v(_vm._s(_vm.activeUser.email))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.updateNewPassword
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('change-avatar-modal', {
    attrs: {
      "value": _vm.changeAvatarDialog
    },
    on: {
      "changeAvatar": _vm.uploadAvatar
    },
    model: {
      value: (_vm.changeAvatarDialog),
      callback: function($$v) {
        _vm.changeAvatarDialog = $$v
      },
      expression: "changeAvatarDialog"
    }
  }), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c39e8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/Toolbar.vue
// module id = 1972
// module chunks = 0